import React from 'react'

const SearchResultsLabel = ({
  totalRecords,
  totalResults,
  className,
  isLoading,
}) => {
  const totalRecordsStr = totalRecords.toLocaleString().replace(/\D\d\d$/, '')
  const totalResultsStr = totalResults.toLocaleString().replace(/\D\d\d$/, '')
  return (
    <div className={className}>
      <h3>
        {isLoading && 'Showing...'}
        {!isLoading && (
          <React.Fragment>
            {totalRecords === 1 &&
          `Showing ${totalResultsStr} record`}

            {totalRecords !== 0 &&
          totalResults !== 0 &&
          `Showing ${totalResultsStr} of ${totalRecordsStr} records`}
          &nbsp;
          </React.Fragment>
        )}
      </h3>
    </div>

  )
}
export default SearchResultsLabel



// WEBPACK FOOTER //
// ./src/legacy/components/Search/SearchResultsLabel.jsx